import Http from '@/utils/http/index';

/**
 * 格式化 VA 数据
 * @param {*} data
 * @returns
 */
const formatVA = (data) => {
  if (!data) {
    return data;
  }
  try {
    let tipList = [];
    if (data.tips) {
      const tips = JSON.parse(data.tips);
      tipList = tips.map(item => JSON.parse(item));
    }
    data.tipList = tipList;

    const infoList = [];
    if (data.accountInfo) {
      const info = JSON.parse(data.accountInfo);
      // 排序
      const keyLabelMap = {
        Currency: 'message.tableCommon.currency',
        'SORT CODE': null,
        'ABA Routing Number': null,
        'ABA/Routing Number': null,
        'Transit Branch': null,
        'Institution Number': null,
        'Account Number': 'message.collection.accountNumber',
        IBAN: 'message.collection.iban',
        'Account Type': 'message.collection.accountType',
        'SWIFT/BIC': 'message.collection.swift',
        'Bank Name': 'message.tableCommon.bankName',
        'Bank Country': 'message.collection.bankCountry',
        'Bank Address': 'message.tableCommon.bankAddress',
        Note: 'message.collection.note',
      };
      const keys = ['Currency', 'SORT CODE', 'ABA Routing Number', 'ABA/Routing Number', 'Transit Branch', 'Institution Number',
        'Account Number', 'IBAN', 'Account Type', 'SWIFT/BIC', 'Bank Name', 'Bank Country',
        'Bank Address', 'Note'];
      keys.forEach(k => {
        const v = info[k];
        if (v) {
          infoList.push({
            label: keyLabelMap[k] || k,
            value: v,
            isInternationalization: !!keyLabelMap[k],
          });
          delete info[k];
        }
      });
      Object.keys(info).forEach(key => {
        info[key] && infoList.push({
          label: key,
          value: info[key],
        });
      });
    }
    data.infoList = infoList;
  } catch (err) {
    //
  }
  return data;
};

// 获取 VA 列表
export function getVAList(params) {
  return Http.get('/merchantVaApply/list', { params });
}

// 新增 VA
export async function addVAInfo(data) {
  const res = await Http.post('/merchantVaApply/add', data);
  return formatVA(res);
}

// 获取 VA 详情
export async function getVADetail(params) {
  const res = await Http.get('/merchantVaApply/merchantVaDetail', { params });
  return formatVA(res);
}

export function updateUserVAInfo(data) {
  return Http.post('/app/reSubmitUserApp', data);
}

// 通过币种获取VA详情
export async function getVaAccountInfoByCurrency(params = {}) {
  console.log('params', params);
    const payInInfoList = await Http.get(`/payoutMerchant/payInInfo?currency=${params.currency}`);
    for (let i = 0; i < payInInfoList.length; i++) {
      const item = payInInfoList[i];
      if (item.currency) {
        return {
          infoList: [{
            label: 'message.tableCommon.currency',
            value: item.currency,
            isInternationalization: true,
          }, {
            label: 'message.contact.accountNumber',
            value: item.account,
            isInternationalization: true,
          }, {
            label: 'message.collection.accountHolderName',
            value: item.holder,
            isInternationalization: true,
          }, {
            label: 'message.collection.companyAddress',
            value: item.companyAddress,
            isInternationalization: true,
          }, {
            label: 'message.tableCommon.bankName',
            value: item.bank,
            isInternationalization: true,
          }, {
            label: 'message.collection.bankLocation',
            value: item.location,
            isInternationalization: true,
          }, {
            label: 'message.tableCommon.bankAddress',
            value: item.address,
            isInternationalization: true,
          }, {
            label: 'message.contact.swiftCode',
            value: item.code,
            isInternationalization: true,
          }, {
            label: 'message.transfer.payoutPostscri',
            value: item.postscript,
            isInternationalization: true,
          }],
        };
      }
  }
  const res = await Http.get('/merchant/account/getVaAccountInfoByCurrency', { params });
  return formatVA(res);
}
